// extracted by mini-css-extract-plugin
export var measureBox = "_5q-0";